import React from 'react';
import { useTranslation } from 'react-i18next';
import { isRTL } from '../../i18n/config';
import SaasContainer from '../saas/Container';
import SaasButton from '../saas/Button';

const NewServicesHeader = ({ compact = false }) => {
  const { t, i18n } = useTranslation();
  const rtl = isRTL(i18n.language);

  if (compact) {
    return (
      <SaasContainer className="pb-5 pt-2 md:pb-6 md:pt-3">
        <div className="flex flex-col items-center gap-5 text-center md:gap-6">
          <div className="mx-auto max-w-2xl space-y-3 md:space-y-3.5">
            <h2 className="type-section-title text-balance text-2xl md:text-heading-lg">
              {t('newServices.title')}{' '}
              <span role="img" aria-hidden className="inline-block align-text-bottom text-[1.25em] leading-none">
                🔥
              </span>
            </h2>
            <p className="type-lead mx-auto max-w-[40rem] text-base md:text-lg">
              {t('newServices.description')}
            </p>
          </div>
          <SaasButton to="/products" variant="gradient" className="shrink-0 md:px-6">
            {t('newServices.more')}
          </SaasButton>
        </div>
      </SaasContainer>
    );
  }

  return (
    <SaasContainer className="pb-6 pt-8 md:pb-8 md:pt-10">
      <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between md:gap-10 lg:gap-12">
        <div className={`min-w-0 flex-1 space-y-3 text-center md:space-y-3.5 ${rtl ? 'md:text-right' : 'md:text-left'}`}>
          <h2 className="type-section-title text-balance text-2xl md:text-heading-lg">
            {t('newServices.title')}{' '}
            <span role="img" aria-hidden className="inline-block align-text-bottom text-[1.25em] leading-none">
              🔥
            </span>
          </h2>
          <p className="type-lead mx-auto max-w-[40rem] md:mx-0 md:max-w-none md:text-base">
            {t('newServices.description')}
          </p>
        </div>
        <SaasButton
          to="/products"
          variant="gradient"
          className="w-full shrink-0 md:w-auto md:self-center md:px-6"
        >
          {t('newServices.more')}
        </SaasButton>
      </div>
    </SaasContainer>
  );
};

export default NewServicesHeader;
